/**
 * Application configuration from environment variables.
 * All required variables are validated at startup.
 */

function getRequiredEnv(key: string): string {
    const value = import.meta.env[key];
    if (!value) {
        throw new Error(`Missing required environment variable: ${key}`);
    }
    return value;
}

const config = {
    clientId: getRequiredEnv('VITE_CLIENT_ID'),
    backendUrl: getRequiredEnv('VITE_BACKEND_URL'),
    apiScope: getRequiredEnv('VITE_API_SCOPE'),
    disableAuth: import.meta.env.DEV && import.meta.env.VITE_DISABLE_AUTH === 'true',
};

export default config;
